import React from "react";
import { observer } from "mobx-react";
import { Tabs } from "antd";
import { BookOutlined } from "@ant-design/icons";
import { useHistory } from "react-router-dom";
import { Page } from "@app/components/page";
import Wand from "@app/assets/icons/wand";
import { useSidebar } from "../page/sidebar";
import BookmarkList from "./bookmark/list";
import { getBookmarkLink } from "./bookmark/utils";
import AIChat from "@app/components/ai-chat";
import { AI_SOURCE_TYPE } from "@app/constants";

import state from "@app/state/store/report/document/bookmarks";

import "./sidebar/style/sidebar.scoped.scss";

const BOOKMARKS_TAB = "bookmarks";
const AI_CHAT_TAB = "AI chat";

const BookmarkSidebar = observer(
    ({
        width = 400,
        document,
        onRestore,
        readonly = false,
        isFullPage = false,
        enableAI = false,
        ...rest
    }) => {
        const sidebar = useSidebar();
        const history = useHistory();

        const [activeKey, setActiveKey] = React.useState();
        const fileId = document?.getPdfFileId;

        const switchTab = (key) => {
            setActiveKey(key);
        };

        /**
         * Open a bookmark
         */
        const open = (bookmark) => {
            const link = getBookmarkLink({
                bookmark,
                baseUrl: isFullPage ? `/fp/r/${state.project}` : `/r/${state.project}`,
            });

            history.push(link);
        };

        return (
            <Page.Sidebar
                className="document-sidebar"
                sidebar={sidebar}
                width={width}
                padding={false}
                collapsible={true}
                {...rest}
            >
                <Tabs
                    type="card"
                    activeKey={activeKey}
                    onTabClick={switchTab}
                    destroyInactiveTabPane
                >
                    <Tabs.TabPane tab={<BookOutlined className="tab-icon" />} key={BOOKMARKS_TAB}>
                        <BookmarkList onOpen={open} readonly={readonly} />
                    </Tabs.TabPane>

                    {enableAI && fileId && (
                        <Tabs.TabPane tab={<Wand colour="#595959" />} key={AI_CHAT_TAB}>
                            <AIChat
                                source={{
                                    _id: document?._id,
                                    type: AI_SOURCE_TYPE.SOURCE_DOCUMENT,
                                    fileId: fileId,
                                }}
                                enableDialogue={fileId}
                            />
                        </Tabs.TabPane>
                    )}
                </Tabs>
            </Page.Sidebar>
        );
    },
);

export default BookmarkSidebar;
